import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Modal from "react-modal";
import ClipboardJS from "clipboard";
import { toast, ToastContainer } from "react-toastify"; // Import Toastify
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS
import './CoursesView.css';

Modal.setAppElement("#root");

function Courses() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [utmTag, setUtmTag] = useState("");
    const [courseName, setCourseName] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCourses = async () => {
            const token = sessionStorage.getItem('Token');
            const myHeaders = new Headers();
            myHeaders.append("authtoken", token);

            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };

            try {
                const response = await fetch("https://api.libaonline.com/api/v1/course/details", requestOptions);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setData(result?.data?.University_details || []);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, []);

    const generateUTMTag = (id, url) => {
        // Open the modal immediately
        setIsModalOpen(true);

        const user_name = sessionStorage.getItem('UIID');
        const utmSource = user_name;
        const utmMedium = sessionStorage.getItem('UIID');
        const utmCampaign = id;
        const baseUrl = `${url}?source=${utmSource}&medium=${utmMedium}&campaign=${utmCampaign}`;
        const token = sessionStorage.getItem('Token');
        const myHeaders = new Headers();
        myHeaders.append("authToken", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({ "url": baseUrl });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://api.libaonline.com/api/v1/utm/generate", requestOptions)
            .then((response) => response.json())
            .then(() => {
                setUtmTag(baseUrl); // Set the UTM tag once it's generated
                setCourseName(courseName); // Ensure courseName is updated (if applicable)

                // Initialize ClipboardJS for copy functionality
                const clipboard = new ClipboardJS('.copy-btn');
                clipboard.on('success', () => {
                    toast.success("URL copied to clipboard!"); // Show toast message
                });
                clipboard.on('error', () => {
                    toast.error("Failed to copy URL.");
                });
            })
            .catch((error) => {
                console.error("Error generating UTM tag:", error);
                toast.error("Failed to generate UTM tag."); // Show an error toast
            });
    };


    const closeModal = () => {
        setIsModalOpen(false);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="container-fluid main_wrapper h-100 p-lg-3 p-md-2 p-sm-2">
            <div style={{zIndex:"111111111111"}}>
                <ToastContainer /> {/* Add Toast Container */}
            </div>
            <h2 className="mb-4">Courses Overview</h2>

            <DataTable
                columns={[
                    { name: "S.No", selector: (row, index) => index + 1, sortable: true, width: "100px" },
                    { name: "Courses", selector: (row) => row.course_name, sortable: true },
                    { name: "CPR", selector: (row) => row.amount, sortable: true },
                    {
                        name: "Action",
                        cell: (row) => (
                            <>
                                <button
                                    className="btn btn-primary"
                                    style={{ width: "40%", marginRight: "20px" }}
                                    onClick={() => generateUTMTag(row.id, row?.utm_code)}
                                >
                                    UTM
                                </button>
                                <a
                                    href={row.brochure_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-info ml-2"
                                >
                                    Brochure
                                </a>
                            </>
                        ),
                        ignoreRowClick: true,
                        allowOverflow: true,
                        button: true,
                        width: "300px"
                    }
                ]}
                data={data}
                customStyles={{
                    rows: { style: { padding: "10px 15px", fontSize: "14px" } },
                    headCells: { style: { padding: "10px 15px", fontWeight: "bold" } }
                }}
                pagination
                highlightOnHover
                fixedHeader
                fixedHeaderScrollHeight="400px"
            />

            <Modal isOpen={isModalOpen} onRequestClose={closeModal} className="modal-content" overlayClassName="modal-overlay">
                <h2>Generated UTM Tag for {courseName}</h2>
                <div className="utm-content">
                    <p>
                        This is the link to promote the course. Use this URL to track leads coming from your marketing efforts.
                    </p>
                    <input
                        type="text"
                        value={utmTag}
                        readOnly
                        className="utm-input"
                    />
                    <button
                        className="copy-btn btn btn-secondary btn-sm"
                        data-clipboard-text={utmTag}
                    >
                        Copy UTM Tag
                    </button>
                    <p className="utm-description">
                        Once the lead is generated, it will show up on your dashboard for further tracking.
                    </p>
                    <button onClick={closeModal} className="btn btn-danger btn-sm">
                        Close
                    </button>
                </div>
            </Modal>
        </div>
    );
}

export default Courses;
